import { createFileRoute } from '@tanstack/react-router'

import { AppManagerFetch } from '@/app/AppManagerFetch'
import { AppManagerIdentify } from '@/app/AppManagerIdentify'
import ConsentsSettings from '@/consents/components/ConsentsSettings/ConsentsSettings'
import { AnonymousPage } from '@/core/components/AnonymousPage/AnonymousPage'

export const Route = createFileRoute('/consents/$consentKey')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <AppManagerFetch>
      <AppManagerIdentify>
        <AnonymousPage>
          <ConsentsSettings />
        </AnonymousPage>
      </AppManagerIdentify>
    </AppManagerFetch>
  )
}
